module.exports = __webpack_public_path__ + "img/orange_038.b946b5ea.png";